import styled from "styled-components";

export const Container = styled.div`
  height: 56px;
  background: #1a2235;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
`;
export const Logo = styled.img``;
